"use client";

import { useEffect } from "react";
import { claimChunkReload, isChunkLoadError } from "./version-check";

function getSessionStorage(): Storage | null {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

function reloadOnceAfterChunkLoadError(errorOrReason: unknown) {
  if (!isChunkLoadError(errorOrReason)) return;
  const storage = getSessionStorage();
  if (storage && claimChunkReload(storage, Date.now())) window.location.reload();
}

export default function ChunkErrorReload() {
  useEffect(() => {
    const handleError = (event: ErrorEvent) => reloadOnceAfterChunkLoadError(event.error);
    const handleRejection = (event: PromiseRejectionEvent) =>
      reloadOnceAfterChunkLoadError(event.reason);

    window.addEventListener("error", handleError);
    window.addEventListener("unhandledrejection", handleRejection);
    return () => {
      window.removeEventListener("error", handleError);
      window.removeEventListener("unhandledrejection", handleRejection);
    };
  }, []);

  return null;
}
